import { Inject, Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { GenericService } from './generic.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class OutreachService {
  urlConstants:any = {
    GET_OUTREACH: 'api/candidate/out-reach',
    GET_OUTREACH_FEEDBACK_QUESTIONS: 'api/feedbackanswers/out-reach',
    GET_OUTREACH_FILTERS: 'api/candidate/out-reach/filters'
  }

  constructor(
    @Inject(StorageService) private StorageService: StorageService,
    @Inject(GenericService) private genericService: GenericService,
    @Inject(AuthService) private authService: AuthService) { }

  getCandidateOutreachDetails(candidateId, companyId, successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_OUTREACH + '/' + candidateId + '/' + companyId).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  saveCandidateOutreachDetails(payload, candidateId, companyId, successCallback, errorCallback) {
    this.genericService.putObject(this.StorageService.get('baseurl') + this.urlConstants.GET_OUTREACH + '/' + candidateId + '/' + companyId, payload).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  getOutreachFeedbackQuestions(candidateId, companyId, successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_OUTREACH_FEEDBACK_QUESTIONS + '/' + candidateId + '/' + companyId).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  saveOutreachFeedbackQuestions(payload, candidateId, companyId, successCallback, errorCallback) {
    this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.GET_OUTREACH_FEEDBACK_QUESTIONS + '/' + candidateId + '/' + companyId, payload).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  getOutreachFilters(successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_OUTREACH_FILTERS).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  setCompanyLocationLabel(jobMatch, isStaffingCompany) {
    let company = '';
    if (isStaffingCompany) {
      if (!jobMatch.sharedRequisition) {
        company = jobMatch.clientName ? jobMatch.clientName : jobMatch.company;
      } else {
        company = jobMatch.corporateName + (jobMatch.corporateBU ? ('/' + jobMatch.corporateBU) : "");
      }
    } else {
      company = jobMatch.corporateBU ? jobMatch.corporateBU : (jobMatch.clientName ? jobMatch.clientName : 'Corporate');
    }

    let location = jobMatch.companyLocation || {};
    ; let city = location.city && location.city.name ? location.city.name : '';
    let state = location.state ? location.state : '';

    var locationLabel = '';
    if (city && state) {
      locationLabel = city + ', ' + state;
    } else if (city || state) {
      locationLabel = city || state;
    }

    jobMatch.companyLabel = company;
    jobMatch.locationLabel = locationLabel;
    jobMatch.companyLocationLabel = company
      ? (locationLabel ? company + ' @ ' + locationLabel : company)
      : locationLabel;
  }

  setMissedOrMatchedInfo(missingInfo, workLocations) {
    const messages: string[] = [];

    if (missingInfo) {
      // Zip Code
      if (missingInfo.zipCodeIcon === 'UNAVAILABLE' || !missingInfo.zipCodeIcon || missingInfo.zipCodeIcon === 'WHITE') {
        messages.push('Zip Code missing');
      } else if (missingInfo.zipCodeIcon === 'RED') {
        messages.push('Zip Code mismatch');
      }

      // Preferred Job Type
      if (missingInfo.preferredJobIcon === 'UNAVAILABLE' || !missingInfo.preferredJobTypeDetails) {
        messages.push('Preferred Job Type missing');
      } else if (missingInfo.preferredJobIcon === 'RED') {
        messages.push('Preferred Job Type mismatch');
      }

      // Salary/Rate
      if (missingInfo.salaryIcon === 'UNAVAILABLE') {
        messages.push('Salary/Rate missing');
      } else if (missingInfo.salaryIcon === 'RED') {
        messages.push('Salary/Rate mismatch');
      }

      // Sponsorships
      if (missingInfo.sponsorshipIcon === 'UNAVAILABLE' || !missingInfo.sponsorships || missingInfo.sponsorships.length == 0) {
        messages.push('Employment Eligibility missing');
      } else if (missingInfo.sponsorshipIcon === 'RED') {
        messages.push('Employment Eligibility mismatch');
      }

      // // Work location
      if (!workLocations || workLocations.length === 0) {
        messages.push('Preferred Work location missing');
      } else if (!this.isWorkLocationsMatching(workLocations, missingInfo.requisitionWorkLocationModes)) {
        messages.push('Work location mismatch');
      }

      // Additional Info
      if (missingInfo.additionalInfoUrlIcon === 'UNAVAILABLE' || !missingInfo.urls || missingInfo.urls.length === 0) {
        messages.push('Profile URL information missing');
      }
    }

    return messages;
  }

  isWorkLocationsMatching(workLocations, requisitionWorkLocations) {
    if (requisitionWorkLocations && requisitionWorkLocations.length > 0) {
      return workLocations.some(obj => requisitionWorkLocations.includes(obj.name));
    } else {
      return true;
    }
  }

  formatOutreachStatus(string) {
    return string
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  setJobDetailsLabel(jobMatch, jobTypeList, salaryDurationOptions) {
    let jobDetails = {
      preferredJobType: 'Not Available',
      salary: 'Not Available',
      sponsorships: 'Not Available',
      workLocations: 'Not Available',
      additionalInformation: 'Not Available'
    };

    const missing = jobMatch.missingOrNonMatchedInfo;
    if (!missing) {
      return jobDetails;
    }

    // Work Locations
    if (missing.requisitionWorkLocationModes && missing.requisitionWorkLocationModes.length > 0) {
      jobDetails.workLocations = missing.requisitionWorkLocationModes.join(", ");
    }

    // Salary
    if (missing.requisitionSalary) {
      const sal = missing.requisitionSalary;
      let message = '';

      if (!sal.salaryType) {
        message = 'Not Available';
      } else if (sal.salaryType === 'SPECIFIC') {
        message = `${sal.maxSalary} ${sal.currency} ${this._getUOM(sal.salaryDuration, salaryDurationOptions)}`;
      } else if (sal.salaryType === 'RANGE') {
        if (sal.minSalary !== sal.maxSalary) {
          message = `${sal.minSalary} to ${sal.maxSalary} ${sal.currency} ${this._getUOM(sal.salaryDuration, salaryDurationOptions)}`;
        } else {
          message = 'Not Available';
        }
      }

      jobDetails.salary = message;
    }

    // Sponsorships
    if (missing.requisitionSponsorships && missing.requisitionSponsorships.length > 0) {
      jobDetails.sponsorships = missing.requisitionSponsorships.join(", ");
    }

    // Preferred Job Type
    if (missing.requisitionJobType && jobTypeList) {
      const found = jobTypeList.find(jobType => jobType.value === missing.requisitionJobType);
      if (found) {
        jobDetails.preferredJobType = found.name;
      }
    }

    return jobDetails;
  }


  _getUOM(salaryDuration, salaryDurationOptions) {
    let uom: any = _.find(salaryDurationOptions, { 'value': salaryDuration });
    // return uom.name;
    return uom ? uom.name : "";
  }

  setDaysSinceOutreach(jobMatch) {
    if (!jobMatch || !jobMatch.dateOfOutreach) {
      return 'Today';
    }

    const outreachDate = new Date(jobMatch.dateOfOutreach);
    const today = new Date();

    outreachDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = today.getTime() - outreachDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
      return 'Today';
    } else if (diffDays === 1) {
      return '1 Day';
    } else {
      return `${diffDays} Days`;
    }
  }

  setCandidateMatchingLabel(jobMatch) {
    return jobMatch.jobMatchCategory ? jobMatch.jobMatchCategory : 'N/A';
  }

  setNoLongerMatch(missingOrNonMatchedInfo = []) {
    const noLongerMatchReasons = [
      'Preferred Job Type missing',
      'Preferred Job Type mismatch',
      'Employment Eligibility missing',
      'Employment Eligibility mismatch',
      'Preferred Work location missing',
      'Work location mismatch',
      'Zip Code mismatch'
    ];

    return noLongerMatchReasons.some(reason =>
      missingOrNonMatchedInfo.includes(reason)
    );
  }

  setOureachExpiryDate(jobMatch) {
    return jobMatch.outreachExpiryDateTime ? moment(jobMatch.outreachExpiryDateTime).format("MMM DD, YYYY hh:mm A") : null;
  }

  setOutreachQuestionsSavedInDraft(state) {
    return state && state != '' && state.includes('SOFT');
  }

}
